import React from 'react';

import styles from './styles.module.scss';

export default function NotificationHeading(props) {

  const { heading, description } = props;

  return (
    <div className={`${styles.headingBlock}`}>
      <h2 className={`${styles.heading}`}>{heading}</h2>
      <p className={`${styles.description}`}>{description}</p>
    </div>
  )
}
